module.exports = __webpack_public_path__ + "media/whats_your_status_series/step-03-8fffe717.jpg";